import { AudioInputState, AudioInputStateFile } from "@/types/defs/audioInput";
import { isSelectedFile } from "@/utils/selectedFileCover/is/isSelectedFile";

export const isAudioInputFile = (
  audioInput: AudioInputState
): audioInput is AudioInputStateFile => {
  const selectedFileCover = audioInput.selectedFileCover;
  return selectedFileCover !== null && isSelectedFile(selectedFileCover);
};
